const guiColors = {
    'motion-primary': 'oklab(0.42 0.16 -0.10)',
    'motion-primary-transparent': 'oklab(0.42 0.16 -0.10 / 0.75)',
    'motion-tertiary': 'oklab(0.34 0.15 -0.09)',

    'looks-secondary': 'oklab(0.42 0.16 -0.10)',
    'looks-transparent': 'oklab(0.42 0.16 -0.10 / 0.35)',
    'looks-light-transparent': 'oklab(0.42 0.16 -0.10 / 0.15)',
    'looks-secondary-dark': 'oklab(0.34 0.15 -0.09)',

    'extensions-primary': 'oklab(0.52 0.17 -0.11)',
    'extensions-tertiary': 'oklab(0.35 0.00 0.00)',
    'extensions-transparent': 'oklab(0.52 0.17 -0.11 / 0.35)',
    'extensions-light': 'oklab(0.85 0.00 0.00)',

    'drop-highlight': 'oklab(0.72 0.00 0.00)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.10 0.00 0.00 / 0.75) 0%, ' +
        'oklab(0.72 0.00 0.00 / 0.75) 33%, ' +
        'oklab(1.00 0.00 0.00 / 0.75) 66%, ' +
        'oklab(0.42 0.16 -0.10 / 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.42 0.16 -0.10)',
    checkboxActiveBorder: 'oklab(0.72 0.00 0.00)'
};

export {
    guiColors,
    blockColors
};
